import React from "react";
import {
  // Collapse,
  Navbar,
  NavbarBrand,
  // Nav
} from "reactstrap";
// Font Awesome Stuff
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow, faGlobe } from "@fortawesome/pro-light-svg-icons";
import { sendAnalytics } from "../../helpers";

const AuthNavBar = (props) => {
  const { page, investorId } = props;
  const todaysDate = new Date();
  const websiteProvided =
    page?.company_website &&
    page?.company_website !== " " &&
    page?.company_website !== "null" &&
    page?.company_website !== "undefined";
  // const [isOpen, setIsOpen] = useState(false);
  // const toggle = () => setIsOpen(!isOpen);
  return (
    <div className={"navigation-container desktop-nav-container"}>
      <Navbar color="light" light expand="md">
        <NavbarBrand
          href={websiteProvided ? page.company_website : "/"}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: page.primary_color,
            fontSize: "22px",
            fontWeight: "bold",
          }}
        >
          {page.logo ? (
            <img className="logo logo-resize" src={page.logo} alt={page.name} />
          ) : (
            page.name
          )}
        </NavbarBrand>

        <div
          className={
            "d-flex pull-right company-type-icons d-none align-items-center"
          }
          style={{ marginTop: "0" }}
        >
          {page.location && (
            <div className="d-flex page-location align-items-center">
              <FontAwesomeIcon
                icon={faLocationArrow}
                fixedWidth
                size="2x"
                className="mr-2"
                style={{ color: props.page.primary_color }}
              />
              <strong className="text-black">{page.location}</strong>
            </div>
          )}
          {websiteProvided && (
            <a
              className="d-flex justify-content-center page-company-website align-items-center ml-5 text-reset text-decoration-none"
              href={page.company_website}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                sendAnalytics({
                  event: "WEBSITE_CLICK",
                  event_type: "CONTACT",
                  event_amount: 1,
                  event_date: todaysDate,
                  pitch_page_id: page?.pitch_page_id,
                  contact_id: investorId,
                })
              }
            >
              <div>
                <FontAwesomeIcon
                  icon={faGlobe}
                  fixedWidth
                  size="2x"
                  className="mr-2"
                  style={{ color: props.page.primary_color }}
                />
              </div>
              <div>{page.company_website}</div>
            </a>
          )}
          <br />
        </div>
      </Navbar>
    </div>
  );
};

export default AuthNavBar;
